// Tailwind, the generated theme, and the global base styles. First, so a component
// stylesheet can never be ordered ahead of the resets.
import "./app.css";

import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { ErrorBoundary } from "./error-boundary.js";
import { assertPaintTokensResolve } from "./paint.js";

const root = document.getElementById("root");
if (!root) throw new Error("#root missing");

// Before the first render, so a stylesheet fault is a blank screen at boot rather than a crash
// inside a game a child is playing. See `assertPaintTokensResolve`.
assertPaintTokensResolve();
/**
 * The boundary wraps everything, at the root.
 *
 * A component that throws while rendering takes the whole tree down and leaves a blank page — the
 * worst failure this app has, because it happens in front of a class or a five-year-old and offers
 * nothing. Wrapping the root rather than each screen keeps one net for all of them; a per-screen
 * boundary would be a decision to make eight times and forget once.
 */
createRoot(root).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);

// Register the service worker in production only. In dev it would cache the shell and
// make iteration confusing; the versioned-bundle behaviour it enforces is a production
// concern (ADR-002).
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js", { scope: "/" });
  });
}
